<template>
  <div class="edit-container-goods-card" v-loading="loading">
    <template v-if="shipmentContainerCode">
      <PageMain
        :detail="detail"
        :isBooked="currentIsBooked"
        @edit="editContainer"
        @copy="copyContainer"
        @delete="deleteContainer"
        @create-booking="openCreateBooking"
        @append-booking="openAppendBooking"
      />
    </template>

    <div v-else class="edit-container-goods-card__empty">
      <i class="el-icon-box" style="font-size:28px;color:#cbd5e1;" />
      <span>
        {{ $l('tips_choose_container_first') || '请选择货柜查看分配明细' }}
      </span>
    </div>

    <EditContainer
      :visible.sync="editVisible"
      :shipmentContainerCode="shipmentContainerCode"
      :shipmentCode="detail.shipmentCode || ''"
      @reload="onEditReload"
    />
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main.vue'
import EditContainer from '../edit-container/index.vue'

export default {
  components: { PageMain, EditContainer },
  mixins: [EditLoading],
  props: {
    shipmentContainerCode: { type: String, default: '' },
    detail: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
    isBooked: { type: Boolean, default: false },
  },
  data() {
    return {
      editVisible: false,
    }
  },
  computed: {
    currentIsBooked() {
      return this.isBooked || !!this.detail.shipmentBookingCode
    },
  },
  methods: {
    reload() {
      this.$emit('reload')
    },
    editContainer() {
      if (this.currentIsBooked) {
        this.$message.warning(
          this.$l('tips_container_booked_no_edit') ||
            '该货柜已关联订舱，无法编辑'
        )
        return
      }
      this.editVisible = true
    },
    openCreateBooking() {
      if (!this.detail.shipmentContainerCode) return
      this.$emit('create-booking', this.detail)
    },
    openAppendBooking() {
      if (!this.detail.shipmentContainerCode) return
      this.$emit('append-booking', this.detail)
    },
    async onEditReload() {
      this.reload()
    },
    async copyContainer() {
      if (!this.detail.shipmentContainerCode) return

      const confirm = await this.$confirm(
        `${this.$l('tips_confirm_copy_container_prefix') ||
          '确认复制货柜「'}${this.detail.containerName || ''} ${this.detail
          .containerNo || ''}${this.$l('tips_confirm_copy_container_suffix') ||
          '」吗？'}`,
        this.$l('tips_confirm_title') || '提示',
        { type: 'info' }
      ).catch(() => null)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentContainerSaveApi({
          shipmentCode: this.detail.shipmentCode,
          containerCode: this.detail.containerCode,
          containerName: this.detail.containerName,
          containerNo: '',
          sealNo: '',
          extendParameterType: this.detail.extendParameterType,
          extendParameterLength: this.detail.extendParameterLength,
          extendParameterWidth: this.detail.extendParameterWidth,
          extendParameterHeight: this.detail.extendParameterHeight,
          containerBookingVolume: this.detail.containerBookingVolume,
          containerWeight: this.detail.containerWeight,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      this.$message({
        type: 'success',
        message: res.msg || this.$l('message_copy_ok') || '复制成功',
      })
      this.reload()
    },
    async deleteContainer() {
      if (!this.detail.shipmentContainerCode) return
      if (this.currentIsBooked) {
        this.$message.warning(
          this.$l('tips_container_booked_no_delete') ||
            '该货柜已关联订舱，无法删除'
        )
        return
      }

      const confirm = await this.$confirm(
        this.$l('tips_confirm_delete_container') || '确认删除该货柜吗？',
        this.$l('tips_confirm_title') || '提示',
        {
          type: 'warning',
        }
      ).catch(() => null)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentContainerDelApi({
          shipmentContainerCode: this.detail.shipmentContainerCode,
          shipmentCode: this.detail.shipmentCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      this.$message({
        type: 'success',
        message: res.msg || this.$l('message_delete_ok') || '删除成功',
      })
      this.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-container-goods-card {
  flex-shrink: 0;
  background: #fff;
}

.edit-container-goods-card__empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 12px;
}
</style>
